import { BaseService } from '@/modules/Core/services/BaseService'
import type { AxiosResponse } from 'axios'
import type { IResponseApi } from '@/modules/Core/interfaces/api/IApis'
import type { ICaptacionElegible } from '@/modules/Agendamiento/interfaces/ICaptacionElegible'
import type { ICaptacion, CaptacionContexto } from '@/modules/Agendamiento/interfaces/ICaptacion'

export class CaptacionService extends BaseService<ICaptacion> {
  constructor () {
    super({
      baseUrl: 'cita/captacion/'
    })
  }

  async getElegibles (
    coppId: number,
    fechaNacimiento: string,
    fechaCita: string,
    contexto: CaptacionContexto = 'agendamiento'
  ): Promise<AxiosResponse<IResponseApi<ICaptacionElegible[]>>> {
    return this.http.post<IResponseApi<ICaptacionElegible[]>>(
      'elegibles',
      {
        coppId,
        fechaNacimiento,
        fechaCita,
        contexto
      }
    ).catch(this.errorHandle)
  }
}
